var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#F0F9FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66552 13.1868L5.94743 10.485C5.87147 10.4091 5.8335 10.3114 5.8335 10.192C5.8335 10.0727 5.87147 9.97504 5.94743 9.89908L6.54964 9.31315C6.62559 9.22634 6.72054 9.18294 6.83447 9.18294C6.9484 9.18294 7.04877 9.22634 7.13558 9.31315L8.95849 11.1361L12.8647 7.22982C12.9515 7.14301 13.0519 7.09961 13.1658 7.09961C13.2798 7.09961 13.3747 7.14301 13.4507 7.22982L14.0529 7.81575C14.1288 7.89171 14.1668 7.98936 14.1668 8.10872C14.1668 8.22808 14.1288 8.32573 14.0529 8.40169L9.25146 13.1868C9.1755 13.2736 9.07785 13.317 8.95849 13.317C8.83913 13.317 8.74148 13.2736 8.66552 13.1868Z",
    fill: "#171E2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesIcon);
export default __webpack_public_path__ + "static/media/yes-icon.976987ea090b49cd7b515d98b517ea53.svg";
export { ForwardRef as ReactComponent };